module.exports = {
      id: "point-arrow-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "svg-sprite-39dbc991ee8a2ec1b35aeef6495011e2.svg#point-arrow",
      toString: function () {
        return this.url;
      }
    }